export default __webpack_public_path__ + "static/media/PokeballLoading.14e441e8.gif";